import { render, staticRenderFns } from "./AddToWishlist.vue?vue&type=template&id=7577ba20&"
import script from "./AddToWishlist.vue?vue&type=script&lang=js&"
export * from "./AddToWishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports